export default __webpack_public_path__ + "static/1569-25e3587b6db6a88f9925bdb54e85c8df.gif";